export default __webpack_public_path__ + "media/images/logo_transparent-9aedc3a098e790b61726b33fcd385cb4.svg";